import React from 'react';

/** Cartao — superfície de conteúdo. `destaque` usa a cor do escritório (uso raro). */
export default function Cartao({ destaque = false, titulo, acoes, className = '', children }) {
  return (
    <section className={['sj-cartao', destaque ? 'sj-cartao--destaque' : '', className].filter(Boolean).join(' ')}>
      {(titulo || acoes) && (
        <header className="sj-cartao__cabeca">
          {titulo && <h2 className="sj-cartao__titulo">{titulo}</h2>}
          {acoes}
        </header>
      )}
      {children}
    </section>
  );
}
